angular.
module("dx.webapp.grade").
component("dxGradingType", {
	bindings: {
		gradingType: "<",
	},
	templateUrl: "tmpl/grade/grading-type-directive.html",
	controller: "DxGradingTypeController",
	controllerAs: "vm",
});
